import styled from '@emotion/styled';

export const StyledImg = styled.img`
  width: 100%;
  height: auto;
  border-radius: 1.25rem;
  margin-bottom: 3rem;
  @media (max-width: 30rem) {
    margin-bottom: 0.5rem;
  }
`;
